import Immutable from 'immutable';
import { WEEKDAYS_ORDER } from 'app/constants/LocationsConstants';
import getMomentAtLocation from 'app/helpers/locations/getMomentAtLocation';

export default function getUpcomingHours(location, specialHours) {
  const localNow = getMomentAtLocation(location);
  if (!localNow) return null;

  // Determine the regular hours for the next 7 days
  const upcomingRegularHoursInAWeek = location
    .get('sortedHours')
    .flatMap(sorted => {
      const dayIndex = WEEKDAYS_ORDER.indexOf(sorted.get('day'));
      const date = getMomentAtLocation(location).day(dayIndex < localNow.day() ? dayIndex + 7 : dayIndex);
      return (
        sorted.get('hours')?.map(hours => Immutable.Map({ date, hours })) || Immutable.List.of(Immutable.Map({ date }))
      );
    })
    .sortBy(mapped => mapped.get('date').valueOf());

  // Determine the earliest hours of operation
  for (let i = 0; i < upcomingRegularHoursInAWeek.size; i++) {
    const upcomingDate = upcomingRegularHoursInAWeek.getIn([i, 'date']);
    const regularHours = upcomingRegularHoursInAWeek.getIn([i, 'hours']);

    const upcomingSpecialHours = specialHours.find(hours => {
      const localStartDate = getMomentAtLocation(location, hours.get('startDate'));
      const localEndDate = getMomentAtLocation(location, hours.get('endDate'));
      return localStartDate.isSameOrBefore(upcomingDate, 'date') && localEndDate.isSameOrAfter(upcomingDate, 'date');
    });

    const upcomingDateStr = upcomingDate.format('YYYY-MM-DD');
    const openTime = upcomingSpecialHours ? upcomingSpecialHours.get('openTime') : regularHours?.get('openTime');
    const closeTime = upcomingSpecialHours ? upcomingSpecialHours.get('closeTime') : regularHours?.get('closeTime');

    let hours = regularHours;
    if (upcomingSpecialHours?.get('openTime')) {
      hours = upcomingSpecialHours;
    }

    if ((openTime || closeTime) && getMomentAtLocation(location, `${upcomingDateStr}${openTime}`).isAfter(localNow)) {
      return Immutable.Map({
        date: upcomingDate,
        hours
      });
    }
  }

  return null;
}
